import { atom } from 'recoil';
import { userDomain } from '@user';
import { userStateKey } from '../constants';

export const userState = atom<userDomain.User | null>({
  key: userStateKey,
  default: null,
});
